<template>
  <div class="network_info_of_status" @click.stop="lookForNetworkInfo">
    <img class="network_info_of_status_icon" :src="networkInfoStatusForImg">
    <span class="network_info_of_status_text" :style="{ color: networkInfoStatusForText }">{{networkInfoStatus}}</span>

    <!-- 暂时不展示了（20220526产品要求）： -->
    <!-- <div class="data_on_network_quality_container" v-if="networkInfoShow" :style="networkQualityStyle">
      <div class="data_on_network_quality_container_inner_title">
        {{networkInfoStatus === '断网' ? '断网' : `网络指标${networkInfoStatus}`}}
      </div>
      <div
        class="data_on_network_quality_container_inner_item"
        v-for="item in onNetworkQualityArr"
        :key="item.key"
      >
        {{
          `${item.title}：${item.value === '未知' ? '未知' : (item.value + (item.unit ? item.unit : ''))}`
        }}
      </div>
      <div
        class="data_on_network_quality_container_null"
        v-if="!onNetworkQualityArr.length"
      >
        暂无相关信息
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'networkInfoOfStatus',
  data() {
    return {
      haveClickDocBefore: false
    }
  },
  props: {
    networkInfoStatus: {
      type: String,
      default: ''
    },
    onNetworkQualityArr: {
      type: Array,
      default: []
    },
    networkInfoShow: {
      type: Boolean,
      default: false
    },
    networkQualityStyle: {
      type: Object,
      default: {
        width: '400px',
        top: '30px',
        left: '-360px'
      }
    }
    
  },
  computed: {
    networkInfoStatusForImg: function () {
      let networkInfoStatusForImg = ''
      switch (this.networkInfoStatus) {
        case '优':
          networkInfoStatusForImg = require('../../assets/img/icon-signal-best.png')
          break
        case '良':
          networkInfoStatusForImg = require('../../assets/img/icon-signal-good.png')
          break
        case '差':
        case '断网':
          networkInfoStatusForImg = require('../../assets/img/icon-signal-worst.png')
          break
      }
      return networkInfoStatusForImg
    },
    networkInfoStatusForText: function () {
      let networkInfoStatusForText = ''
      switch (this.networkInfoStatus) {
        case '优':
          networkInfoStatusForText = '#00D789'
          break
        case '良':
          networkInfoStatusForText = '#FFA401'
          break
        case '差':
        case '断网':
          networkInfoStatusForText = '#E90201'
          break
      }
      return networkInfoStatusForText
    }
  },
  mounted () {
    const _that = this
    document.addEventListener('click', function () {
      if (_that.networkInfoShow) {
        _that.$emit('lookForNetworkInfo')
        _that.haveClickDocBefore = true
      } else {
        _that.haveClickDocBefore = false
      }
    }, true)
  },
  methods: {
    lookForNetworkInfo () {
      if (this.haveClickDocBefore) {
        this.haveClickDocBefore = false
      } else {
        this.$emit('lookForNetworkInfo')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.network_info_of_status {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  // cursor: pointer;
  margin-left: 16px;
  position: relative;
  .network_info_of_status_icon {
    width: 24px;
  }
  .network_info_of_status_text {
    font-size: 12px;
  }
}
// 网络指标信息的展示：
.data_on_network_quality_container {
  height: auto;
  box-shadow: 1px 1px 8px #ddd;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  border-radius: 10px;
  padding: 10px;
  color: #f5f5f5;
  z-index: 9;
  .data_on_network_quality_container_inner_title {
    width: 100%;
    height: 40px;
    font-weight: bold;
    line-height: 40px;
    border-bottom: 1px dotted #ddd;
  }
  .data_on_network_quality_container_inner_item {
    width: 100%;
    padding: 5px 0;
  }
  .data_on_network_quality_container_null {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ddd;
  }
}
</style>
